import { render, staticRenderFns } from "./leftBottom.vue?vue&type=template&id=19d1aa4c&scoped=true&"
import script from "./leftBottom.vue?vue&type=script&lang=js&"
export * from "./leftBottom.vue?vue&type=script&lang=js&"
import style0 from "./leftBottom.vue?vue&type=style&index=0&id=19d1aa4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d1aa4c",
  null
  
)

export default component.exports